import { render, staticRenderFns } from "./InactiveFBMUsersFilter.vue?vue&type=template&id=c0fd5516&scoped=true"
import script from "./InactiveFBMUsersFilter.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd5516",
  null
  
)

export default component.exports